let counter = 0;
const generateId = () => `id_${Date.now()}_${performance.now().toString(36)}_${++counter}_${Math.random().toString(36).substring(2)}`;

export default generateId;